import {StopwatchIcon} from '@primer/octicons-react'

import styles from './time-bound-filter-warning.module.css'

type TimeBoundFilterWarningProps = {
  field: string
  unit: 'hours'
  value: number
}

export const TimeBoundFilterWarning = ({field, unit, value}: TimeBoundFilterWarningProps) => {
  return (
    <p className={styles.Text}>
      <span aria-hidden="true" className={styles.Box}>
        <StopwatchIcon size={14} />
      </span>
      <span>
        Using the {field} operator means that your workflow will run every {value} {unit}
      </span>
    </p>
  )
}

try{ TimeBoundFilterWarning.displayName ||= 'TimeBoundFilterWarning' } catch {}